import { AccordionDetails, Stack } from "@mui/material";
import type { StackProps } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";

export const StyledAccordionTitle = ({ children, className, ...props }: React.ComponentProps<"h2">) => (
  <h2 className={`m-0 ${className || ""}`} {...props}>
    {children}
  </h2>
);

export const StyledAccordionDetails = styled(AccordionDetails)({
  display: "inline",
  padding: 0,
  margin: 0
})

interface DocumentHeaderProps extends StackProps {
  sticky?: boolean;
}

export const DocumentHeader = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "sticky",
})<DocumentHeaderProps>(({ sticky = true }) => ({
  marginTop: "1rem", // theme.spacing(2)
  marginBottom: "1rem", // theme.spacing(2)
  padding: "1rem", // theme.spacing(2)
  position: sticky ? "sticky" : "static",
  top: sticky ? 0 : "auto",
  zIndex: sticky ? 20 : "auto",
  backgroundColor: "white",
  borderRadius: "0.5rem", // theme.spacing(1)
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px'
}));
